import React, { useState } from 'react';
import loading from '../../Assets/Videos/loading.mp4'; // Import the loading video

// Loader 1 - Horizontal progress bar
const Loader1 = () => (
  <div className="w-60 h-32 flex items-center justify-center">
    <style>
      {`
        .loader-1-container {
          width: 120px;
          height: 120px;
          background-color: black;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .loader-1 {
          width: 90px;
          height: 14px;
          box-shadow: 0 3px 0 #fff;
          background: repeating-linear-gradient(90deg,#fff 0 14px,#0000 0 100%) 0 0/calc(100%/4) 100%;
          animation: l1 1s infinite linear;
        }
        @keyframes l1 {
          100% {background-position:calc(100%/3) 0}
        }
      `}
    </style>
    <div className="loader-1-container">
      <div className="loader-1"></div>
    </div>
  </div> 
);

// Loader 2 - Square with moving dot
const Loader2 = () => (
  <div className="w-60 h-32 flex items-center justify-center">
    <style>
      {`
        .loader-2-container {
          width: 120px;
          height: 120px;
          background-color: black;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .loader-2 {
          width: 40px;
          aspect-ratio: 1;
          outline: 2px solid #fff;
          background:
            radial-gradient(farthest-side,#000 90%,#0000) 0 0/8px 8px no-repeat,
            conic-gradient(from  90deg at 10px 10px,#0000 90deg,#fff 0),
            conic-gradient(from -90deg at 30px 30px,#0000 90deg,#fff 0);
          animation: l2 1.5s infinite;
        }
        @keyframes l2 {
          0%   {background-position:0    0}
          25%  {background-position:100% 0}
          50%  {background-position:100% 100%}
          75%  {background-position:0    100%}
          100% {background-position:0     0}
        }
      `}
    </style>
    <div className="loader-2-container">
      <div className="loader-2"></div>
    </div>
  </div>
);

// Loader 3 - Rectangle with dot and path
const Loader3 = () => (
  <div className=" w-60 h-32 flex items-center justify-center">
    <style>
      {`
        .loader-3-container {
          width: 120px;
          height: 120px;
          background-color: black;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .loader-3 {
          width: 70px;
          height: 40px;
          outline: 2px solid #fff;
          background:
            radial-gradient(farthest-side,#000 90%,#0000) 0 0/8px 8px no-repeat,
            linear-gradient(#fff 0 0) 50%/10px 100% no-repeat,
            conic-gradient(from  90deg at 10px 10px,#0000 90deg,#fff 0),
            conic-gradient(from -90deg at 60px 30px,#0000 90deg,#fff 0);
          animation: l3 2s infinite;
        }
        @keyframes l3 {
          0%    {background-position:0    0   ,50%}
          12.5% {background-position:50%  0   ,50%}
          25%   {background-position:50%  100%,50%}
          37.5% {background-position:100% 100%,50%}
          50%   {background-position:100% 0   ,50%}
          62.5% {background-position:50%  0   ,50%}
          75%   {background-position:50%  100%,50%}
          82.5% {background-position:0    100%,50%}
          100%  {background-position:0    0   ,50%}
        }
      `}
    </style>
    <div className="loader-3-container">
      <div className="loader-3"></div>
    </div>
  </div>
);

// Loader 4 - Filling dots
const Loader4 = () => (
  <div className=" w-60 h-32 flex items-center justify-center">
    <style>
      {`
        .loader-4-container {
          width: 120px;
          height: 120px;
          background-color: black;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .loader-4 {
          display: inline-flex;
          gap: 10px;
        }
        .loader-4:before,
        .loader-4:after {
          content: "";
          height: 20px;
          aspect-ratio: 1;
          border-radius: 50%;
          background:
            linear-gradient(#222 0 0) top/100% 0% no-repeat,
            radial-gradient(farthest-side,#000 95%,#0000) 50%/8px 8px no-repeat
            #fff;
          animation: l4 4s infinite ease-in;
        }
        @keyframes l4 {
          0%  {background-size:100% 0%,8px 8px;background-position:top, 50% 50%}
          80% {background-size:100% 70%,8px 8px;background-position:top, 50% 70%}
          84%,
          100%{background-size:100% 0%,8px 8px;background-position:top, 50% 50%}
        }
      `}
    </style>
    <div className="loader-4-container">
      <div className="loader-4"></div>
    </div>
  </div>
);

// Loader 5 - Pacman-style
const Loader5 = () => (
  <div className=" w-60 h-32 flex items-center justify-center">
    <style>
      {`
        .loader-5-container {
          width: 120px;
          height: 120px;
          background-color: white;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .loader-5 {
          width: 80px;
          height: 80px;
          border-radius: 50%;
          border: 8px solid #d1914b;
          box-sizing: border-box;
          --c:no-repeat radial-gradient(farthest-side, #d64123 94%,#0000);
          --b:no-repeat radial-gradient(farthest-side, #000 94%,#0000);
          background:
            var(--c) 11px 15px,
            var(--b) 6px 15px,    
            var(--c) 35px 23px,
            var(--b) 29px 15px,    
            var(--c) 11px 46px,
            var(--b) 11px 34px,    
            var(--c) 36px 0px,
            var(--b) 50px 31px,
            var(--c) 47px 43px,
            var(--b) 31px 48px,    
            #f6d353; 
          background-size: 15px 15px,6px 6px;
          animation: l5 3s infinite;
        }
        @keyframes l5 {
          0%     {-webkit-mask:conic-gradient(#0000 0     ,#000 0)}
          16.67% {-webkit-mask:conic-gradient(#0000 60deg ,#000 0)}
          33.33% {-webkit-mask:conic-gradient(#0000 120deg,#000 0)}
          50%    {-webkit-mask:conic-gradient(#0000 180deg,#000 0)}
          66.67% {-webkit-mask:conic-gradient(#0000 240deg,#000 0)}
          83.33% {-webkit-mask:conic-gradient(#0000 300deg,#000 0)}
          100%   {-webkit-mask:conic-gradient(#0000 360deg,#000 0)}
        }
      `}
    </style>
    <div className="loader-5-container">
      <div className="loader-5"></div>
    </div>
  </div>
);

// Loader 6 - Matchstick
const Loader6 = () => (
  <div className=" w-60 h-32 flex items-center justify-center">
    <style>
      {`
        .loader-6-container {
          width: 120px;
          height: 120px;
          background-color: white;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .loader-6 {
          width: 35px;
          height: 80px;
          position: relative;
        }
        .loader-6:after {
          content: "";
          position: absolute;
          inset: 0;
          padding: 3px 5px;
          border-top: 1px solid #bbb6aa;
          border-bottom: 4px solid #bbb6aa;
          background: 
            linear-gradient(#612329 0 0) bottom no-repeat content-box, 
            #e4e0d7;
          mix-blend-mode: darken;
          animation: l6 1.5s infinite linear;
        }
        .loader-6:before {
          content: "";
          position: absolute;
          inset: -18px calc(50% - 2px) 8px;
          background: #eb6b3e;   
          transform-origin: bottom;
          transform: rotate(8deg);
        }
        @keyframes l6 {
          0%   {background-size: 100% 100%}
          100% {background-size: 100% 5%}
        }
      `}
    </style>
    <div className="loader-6-container">
      <div className="loader-6"></div>
    </div>
  </div>
);

// Loader 7 - Three segments
const Loader7 = () => (
  <div className=" w-60 h-32 flex items-center justify-center">
    <style>
      {`
        .loader-7-container {
          width: 120px;
          height: 120px;
          background-color: black;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .loader-7 {
          width: 85px;
          height: 50px;
          --g1:conic-gradient(from  90deg at left   3px top   3px,#0000 90deg,#fff 0);
          --g2:conic-gradient(from -90deg at bottom 3px right 3px,#0000 90deg,#fff 0);
          background:var(--g1),var(--g1),var(--g1), var(--g2),var(--g2),var(--g2);
          background-position: left,center,right;
          background-repeat: no-repeat;
          animation: l7 1s infinite;
        }
        @keyframes l7 {
          0%   {background-size:25px 50% ,25px 50% ,25px 50%}
          25%  {background-size:25px 100%,25px 50% ,25px 50%}
          50%  {background-size:25px 50% ,25px 100%,25px 50%}
          75%  {background-size:25px 50% ,25px 50% ,25px 100%}
          100% {background-size:25px 50% ,25px 50% ,25px 50%}
        }
      `}
    </style>
    <div className="loader-7-container">
      <div className="loader-7"></div>
    </div>
  </div>
);

// Loader 8 - Pulsing square
const Loader8 = () => (
  <div className=" w-60 h-32 flex items-center justify-center">
    <style>
      {`
        .loader-8-container {
          width: 120px;
          height: 120px;
          background-color: white;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .loader-8 {
          width: 50px;
          height: 50px;
          background: #000;
          animation: l8 2s infinite;
        }
        @keyframes l8 {
          0% { transform: scale(1); }
          50% { transform: scale(1.5); }
          100% { transform: scale(1); }
        }
      `}
    </style>
    <div className="loader-8-container">
      <div className="loader-8"></div>
    </div>
  </div>
);

// Loader 9 - Animated mask
const Loader9 = () => (
  <div className=" w-60 h-32 flex items-center justify-center">
    <style>
      {`
        .loader-9-container {
          width: 120px;
          height: 120px;
          background-color: white;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .loader-9 {
          width: 35px;
          height: 80px;
          position: relative;
        }
        .loader-9:after {
          content: "";
          position: absolute;
          inset: 0 0 20px;
          border-radius: 50px 50px 10px 10px;
          padding: 1px;
          background: linear-gradient(#ff4d80 33%,#ffa104 0 66%, #01ddc7 0) content-box;
          --c:radial-gradient(farthest-side,#000 94%,#0000);
          -webkit-mask:
            linear-gradient(#0000 0 0),
            var(--c) -10px -10px,
            var(--c)  15px -14px,
            var(--c)   9px -6px,
            var(--c) -12px  9px,
            var(--c)  14px  9px,
            var(--c)  23px 27px,
            var(--c)  -8px 35px,
            var(--c)   50% 50%,
            linear-gradient(#000 0 0);
          mask:
            linear-gradient(#000 0 0),
            var(--c) -10px -10px,
            var(--c)  15px -14px,
            var(--c)   9px -6px,
            var(--c) -12px  9px,
            var(--c)  14px  9px,
            var(--c)  23px 27px,
            var(--c)  -8px 35px,
            var(--c)   50% 50%,
            linear-gradient(#0000 0 0);
          -webkit-mask-composite: destination-out;
          mask-composite: exclude,add,add,add,add,add,add,add,add;
          -webkit-mask-repeat: no-repeat;
          animation: l9 3s infinite;
        }
        .loader-9:before {
          content: "";
          position: absolute;
          inset: 50% calc(50% - 4px) 0;
          background: #e0a267;
          border-radius: 50px;
        }
        @keyframes l9 {
          0%   {-webkit-mask-size: auto,0 0,0 0,0 0,0 0,0 0,0 0,0 0,0 0}
          10%  {-webkit-mask-size: auto,25px 25px,0 0,0 0,0 0,0 0,0 0,0 0,0 0}
          20%  {-webkit-mask-size: auto,25px 25px,25px 25px,0 0,0 0,0 0,0 0,0 0,0 0}
          30%  {-webkit-mask-size: auto,25px 25px,25px 25px,30px 30px,0 0,0 0,0 0,0 0,0 0}
          40%  {-webkit-mask-size: auto,25px 25px,25px 25px,30px 30px,30px 30px,0 0,0 0,0 0,0 0}
          50%  {-webkit-mask-size: auto,25px 25px,25px 25px,30px 30px,30px 30px,25px 25px,0 0,0 0,0 0}
          60%  {-webkit-mask-size: auto,25px 25px,25px 25px,30px 30px,30px 30px,25px 25px,25px 25px,0 0,0 0}
          70%  {-webkit-mask-size: auto,25px 25px,25px 25px,30px 30px,30px 30px,25px 25px,25px 25px,25px 25px,0 0}
          80%,
          100% {-webkit-mask-size: auto,25px 25px,25px 25px,30px 30px,30px 30px,25px 25px,25px 25px,25px 25px,200% 200%}
        }
      `}
    </style>
    <div className="loader-9-container">
      <div className="loader-9"></div>
    </div>
  </div>
);

// Loader 10 - Butterfly
const Loader10 = () => (
  <div className=" w-60 h-32 flex items-center justify-center">
    <style>
      {`
        .loader-10-container {
          width: 120px;
          height: 120px;
          background-color: white;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .loader-10 {
          --c1:#673b14;
          --c2:#f8b13b;
          width: 40px;
          height: 80px;
          border-top: 4px solid var(--c1);
          border-bottom: 4px solid var(--c1);
          background: linear-gradient(90deg, var(--c1) 2px, var(--c2) 0 5px,var(--c1) 0) 50%/7px 8px no-repeat;
          display: grid;
          overflow: hidden;
          animation: l10-0 2s infinite linear;
        }
        .loader-10::before,
        .loader-10::after {
          content: "";
          grid-area: 1/1;
          width: 75%;
          height: calc(50% - 4px);
          margin: 0 auto;
          border: 2px solid var(--c1);
          border-top: 0;
          box-sizing: content-box;
          border-radius: 0 0 40% 40%;
          -webkit-mask: 
            linear-gradient(#000 0 0) bottom/4px 2px no-repeat,
            linear-gradient(#000 0 0);
          -webkit-mask-composite: destination-out;
                  mask-composite: exclude;
          background: 
            linear-gradient(var(--d,0deg),var(--c2) 50%,#0000 0) bottom /100% 205%,
            linear-gradient(var(--c2) 0 0) center/0 100%;
          background-repeat: no-repeat;
          animation: inherit;
          animation-name: l10-1;
        }
        .loader-10::after {
          transform-origin: 50% calc(100% + 2px);
          transform: scaleY(-1);
          --s:3px;
          --d:180deg;
        }
        @keyframes l10-0 {
          80%  {transform: rotate(0)}
          100% {transform: rotate(0.5turn)}
        }
        @keyframes l10-1 {
          10%,70%  {background-size:100% 205%,var(--s,0) 100%}
          70%,100% {background-position: top,center}
        }
      `}
    </style>
    <div className="loader-10-container">
      <div className="loader-10"></div>
    </div>
  </div>
);

// Loader 11 - Cat steps
const Loader11 = () => (
  <div className=" w-60 h-32 flex items-center justify-center">
    <style>
      {`
        .loader-11-container {
          width: 120px;
          height: 120px;
          background-color: white;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .loader-11 {
          width: calc(6*30px);
          height: 50px;
          display: flex;
          color: #8d7958;
          filter: drop-shadow(30px 25px 0 currentColor) drop-shadow(60px 0 0 currentColor) drop-shadow(120px 0 0 currentColor);
          clip-path: inset(0 100% 0 0);
          animation: l11 2s infinite steps(7);
        }
        .loader-11:before {
          content: "";
          width: 30px;
          height: 25px;
          --c:no-repeat radial-gradient(farthest-side,currentColor 92%,#0000);
          background: 
            var(--c) left /70% 70%,
            var(--c) right/20% 20%,
            var(--c) top    0 right 15%/20% 20%,
            var(--c) bottom 0 right 15%/20% 20%;
        }
        @keyframes l11 {
          100% {clip-path: inset(0 -30px 0 0)}
        }
      `}
    </style>
    <div className="loader-11-container">
      <div className="loader-11"></div>
    </div>
  </div>
);

// Loader 12 - Fish
const Loader12 = () => (
  <div className=" w-60 h-32 flex items-center justify-center">
    <style>
      {`
        .loader-12-container {
          width: 120px;
          height: 120px;
          background-color: white;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .loader-12 {
          width: 80px;
          height: 40px;
          background: #83def1;
          position: relative;
          overflow: hidden;
        }
        .loader-12:before {
          content: "";
          position: absolute;
          top: 10px;
          left: 0;
          height: 20px;
          width: 30px;
          background: 
            radial-gradient(farthest-side,#000 50%,#fff 52% 80%,#0000) 78% 22%/5px 5px, 
            radial-gradient(farthest-side, #fb4f05 92%,#0000) right/80% 100%, 
            radial-gradient(farthest-side at left,#fb4f05 92%,#0000) left/35% 80%;
          background-repeat: no-repeat;
          clip-path: polygon(0 0,100% 0,100% 40%,81% 50%,100% 60%,100% 100%,0 100%,20% 50%);
          animation: l12 1.5s infinite;
        }
        @keyframes l12 {
          0%   {transform: translate(-100%)}
          40%  {transform: translate(15px)}
          80%,
          100% {transform: translate(100px)}
        }
      `}
    </style>
    <div className="loader-12-container">
      <div className="loader-12"></div>
    </div>
  </div>
);

// Loader 13 - Pacman-style
const Loader13 = () => (
  <div className=" w-60 h-32 flex items-center justify-center">
    <style>
      {`
        .loader-13-container {
          width: 120px;
          height: 120px;
          background-color: white;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .loader-13 {
          width: 90px;
          height: 24px;
          padding: 2px 0;
          box-sizing: border-box;
          display: flex;
          animation: l13-0 3s infinite steps(6);
          background:
            linear-gradient(#000 0 0) 0 0/0% 100% no-repeat,
            radial-gradient(circle 3px,#eeee89 90%,#0000) 0 0/20% 100%
            #000;
          overflow: hidden;
        }
        .loader-13::before {
          content: "";
          width: 20px;
          transform: translate(-100%);
          border-radius: 50%;
          background: #ffff2d;
          animation: 
            l13-1 .25s .153s infinite steps(5) alternate,
            l13-2  3s        infinite linear;
        }
        @keyframes l13-1{ 
            0% {clip-path: polygon(50% 50%,100%   0,100% 0,0 0,0 100%,100% 100%,100% 100%)}
          100% {clip-path: polygon(50% 50%,100% 65%,100% 0,0 0,0 100%,100% 100%,100%  35%)}
        }
        @keyframes l13-2{ 
          100% {transform: translate(90px)}
        }
        @keyframes l13-0{ 
          100% {background-size:120% 100%,20% 100%}
        }
      `}
    </style>
    <div className="loader-13-container">
      <div className="loader-13"></div>
    </div>
  </div>
);

// Loader 14 - Typewriter
const Loader14 = () => (
  <div className=" w-60 h-32 flex items-center justify-center">
    <style>
      {`
        .loader-14-container {
          width: 120px;
          height: 120px;
          background-color: white;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .loader-14 {
          width: 70px;
          height: 50px;
          box-sizing: border-box;
          background:
            conic-gradient(from 135deg at top,#0000, #fff 1deg 90deg,#0000 91deg) right -20px bottom 8px/18px 9px,
            linear-gradient(#fff 0 0) bottom/100% 8px,
            #000;
          background-repeat: no-repeat;
          border-bottom: 8px solid #000;
          position: relative;
          animation: l14-0 2s infinite linear;
        }
        .loader-14::before {
          content: "";
          position: absolute;
          width: 10px;
          height: 14px;
          background: lightblue;
          left: 10px;
          animation: l14-1 2s infinite cubic-bezier(0,200,1,200);
        }
        @keyframes l14-0{
          100% { background-position: left -20px bottom 8px,bottom}
        }
        @keyframes l14-1{
          0%,50%   {bottom: 8px}
          90%,100% {bottom: 8.1px}
        }
      `}
    </style>
    <div className="loader-14-container">
      <div className="loader-14"></div>
    </div>
  </div>
);

// Loader 15 - Bouncing ball
const Loader15 = () => (
  <div className=" w-60 h-32 flex items-center justify-center">
    <style>
      {`
        .loader-15-container {
          width: 120px;
          height: 120px;
          background-color: white;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .loader-15 {
          height: 60px;
          aspect-ratio: 2;
          border-bottom: 3px solid #524656;
          position: relative;
          overflow: hidden;
        }
        .loader-15:before {
          content: "";
          position: absolute;
          inset: auto 42.5% 0;
          aspect-ratio: 1;
          border-radius: 50%;
          background: #CF4647;
          animation: 
            l15-0 .5s cubic-bezier(0,900,1,900) infinite,
            l15-1  2s linear infinite;
        }
        @keyframes l15-0 {
          0%,2% {bottom: 0%}
          98%,to {bottom:.1%}
        }
        @keyframes l15-1 {
          0% {translate: -500%}
          to {translate:  500%}
        }
      `}
    </style>
    <div className="loader-15-container">
      <div className="loader-15"></div>
    </div>
  </div>
);

// Loader 16 - Three bars
const Loader16 = () => (
  <div className=" w-60 h-32 flex items-center justify-center">
    <style>
      {`
        .loader-16-container {
          width: 120px;
          height: 120px;
          background-color: white;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .loader-16 {
          width: 45px;
          aspect-ratio: 1;
          --c: no-repeat linear-gradient(#000 0 0);
          background: 
            var(--c) 0%   50%,
            var(--c) 50%  50%,
            var(--c) 100% 50%;
          background-size: 20% 100%;
          animation: l16 1s infinite linear;
        }
        @keyframes l16 {
          0%  {background-size: 20% 100%,20% 100%,20% 100%}
          33% {background-size: 20% 10% ,20% 100%,20% 100%}
          50% {background-size: 20% 100%,20% 10% ,20% 100%}
          66% {background-size: 20% 100%,20% 100%,20% 10% }
          100%{background-size: 20% 100%,20% 100%,20% 100%}
        }
      `}
    </style>
    <div className="loader-16-container">
      <div className="loader-16"></div>
    </div>
  </div>
);

// Loader 17 - Rotating spokes
const Loader17 = () => (
  <div className=" w-60 h-32 flex items-center justify-center">
    <style>
      {`
        .loader-17-container {
          width: 120px;
          height: 120px;
          background-color: white;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .loader-17 {
          width: 50px;
          aspect-ratio: 1;
          display: grid;
          color: #854f1d;
          background: radial-gradient(farthest-side, currentColor calc(100% - 6px),#0000 calc(100% - 5px) 0);
          -webkit-mask: radial-gradient(farthest-side,#0000 calc(100% - 13px),#000 calc(100% - 12px));
          border-radius: 50%;
          animation: l17 2s infinite linear;
        }
        .loader-17::before,
        .loader-17::after {    
          content: "";
          grid-area: 1/1;
          background:
            linear-gradient(currentColor 0 0) center,
            linear-gradient(currentColor 0 0) center;
          background-size: 100% 10px,10px 100%;
          background-repeat: no-repeat;
        }
        .loader-17::after {
           transform: rotate(45deg);
        }
        @keyframes l17 { 
          100%{transform: rotate(1turn)}
        }
      `}
    </style>
    <div className="loader-17-container">
      <div className="loader-17"></div>
    </div>
  </div>
);

// Loader 18 - Progress bar
const Loader18 = () => (
  <div className=" w-60 h-32 flex items-center justify-center">
    <style>
      {`
        .loader-18-container {
          width: 120px;
          height: 120px;
          background-color: white;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .loader-18 {
          height: 4px;
          width: 130px;
          --c:no-repeat linear-gradient(#6100ee 0 0);
          background: var(--c),var(--c),#d7b8fc;
          background-size: 60% 100%;
          animation: l18 3s infinite;
        }
        @keyframes l18 {
          0%   {background-position:-150% 0,-150% 0}
          66%  {background-position: 250% 0,-150% 0}
          100% {background-position: 250% 0, 250% 0}
        }
      `}
    </style>
    <div className="loader-18-container">
      <div className="loader-18"></div>
    </div>
  </div>
);

// Loader 19 - Jumping dots on line
const Loader19 = () => (
  <div className=" w-60 h-32 flex items-center justify-center">
    <style>
      {`
        .loader-19-container {
          width: 120px;
          height: 120px;
          background-color: white;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .loader-19 {
          height: 60px;
          aspect-ratio: 2;
          border-bottom: 3px solid #0000;
          background: 
            linear-gradient(90deg,#524656 50%,#0000 0)
            -25% 100%/50% 3px repeat-x border-box;
          position: relative;
          animation: l19-0 .75s linear infinite;
        }
        .loader-19:before {
          content: "";
          position: absolute;
          inset: auto 42.5% 0;
          aspect-ratio: 1;
          border-radius: 50%;
          background: #CF4647;
          animation: l19-1 .75s cubic-bezier(0,900,1,900) infinite;
        }
        @keyframes l19-0 {
          to {background-position: -125% 100%}
        }
        @keyframes l19-1 {
          0%,2% {bottom: 0%}
          98%,to {bottom:.1%}
        }
      `}
    </style>
    <div className="loader-19-container">
      <div className="loader-19"></div>
    </div>
  </div>
);



// Loader 20 - Video loader
const Loader20 = () => (
  <div className='w-80 h-40 flex items-center justify-center'>
    <style>
      {`
        .loader-20-container {
          width: 160px;
          height: 160px;
          background-color: white;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          overflow: hidden;
        }
        .loader-20-video {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      `}
    </style>
    <div className="loader-20-container">
      <video 
        className="loader-20-video"
        src={loading}
        autoPlay
        loop
        muted
        playsInline
      />
    </div>
  </div>
);

const LoadingScreen = () => {
  const loaders = [Loader1 , Loader2, Loader3, Loader4, Loader5, Loader6, Loader7, Loader8, Loader9, Loader10, Loader11, Loader12, Loader13, Loader14, Loader15, Loader16, Loader17, Loader18, Loader19, Loader20];
  const [currentLoader, setCurrentLoader] = useState(() => {
    // Get previously shown loaders from localStorage
    const recentLoaders = JSON.parse(localStorage.getItem('recentLoaders') || '[]');
    
    // Create array of all available loader indices
    const availableLoaders = Array.from({ length: loaders.length }, (_, i) => i)
      .filter(index => !recentLoaders.includes(index));
    
    // If all loaders have been recently shown or no history exists, use any random loader
    if (availableLoaders.length === 0) {
      return Math.floor(Math.random() * loaders.length);
    }
    
    // Pick a random loader from the ones not recently shown
    const randomIndex = Math.floor(Math.random() * availableLoaders.length);
    const newLoader = availableLoaders[randomIndex];
    
    // Update history (keep last 5 loaders in history)
    const updatedRecentLoaders = [...recentLoaders, newLoader].slice(-5);
    localStorage.setItem('recentLoaders', JSON.stringify(updatedRecentLoaders));
    
    return newLoader;
  });
  const RandomLoader = loaders[currentLoader];

  const changeLoader = () => {
    setCurrentLoader(Math.floor(Math.random() * loaders.length));
  };

  return (
    <div className="fixed inset-0 flex flex-col items-center justify-center bg-black/70 z-[100] h-full">
      <RandomLoader />
      <h1 className='text-4xl text-white font-bold'>Please Wait!</h1>
      
    </div>
  );
};

export default LoadingScreen;

